import styled from '@emotion/styled'
import { calcRem, zIndex } from '../../../__styling'
import { colorsPN } from '@news-mono/design-tokens'
import { PNCardOverlayButtonScale } from '../cards/PNArticleCard'

interface StyledPNVideoPlayButtonProps {
    overlayButtonScale: PNCardOverlayButtonScale
    isCentred?: boolean
    hidden?: boolean
    hasBackground?: boolean
}

export const StyledPNVideoPlayButton =
    styled.button<StyledPNVideoPlayButtonProps>(
        ({ overlayButtonScale = 'M', isCentred, hidden, hasBackground }) => {
            const iconStyle = getPlayIconStyle(overlayButtonScale)

            const positionStyle = isCentred
                ? {
                      left: '50%',
                      top: '50%',
                      transform: 'translate(-50%, -50%)',
                  }
                : {
                      left: calcRem(iconStyle.marginLeft),
                      bottom: calcRem(iconStyle.marginBottom),
                  }

            return {
                display: hidden ? 'none' : 'block',
                background: hasBackground
                    ? colorsPN.background.brand.strong
                    : colorsPN.fill.weak,
                transition: 'all .25s ease-in-out',
                border: 'none',
                cursor: 'pointer',

                position: 'absolute',
                height: calcRem(iconStyle.size),
                width: calcRem(iconStyle.size),
                borderRadius: `${iconStyle.size / 2}px`,
                zIndex: zIndex.common.videoPlayButton,
                ...positionStyle,

                '&:hover': {
                    background: colorsPN.background.brand.strong,
                },

                svg: {
                    transform: `translateY(${calcRem(iconStyle.svgOffset)})`,
                    width: calcRem(iconStyle.svgWidth),
                },
            }
        },
    )

// To decide the button size defined here: https://www.figma.com/design/3veq2RFYCAfwUqTSUuHln8/PerthNow-Design-System?node-id=436-74788&node-type=frame&m=dev
function getPlayIconStyle(overlayButtonScale: PNCardOverlayButtonScale) {
    switch (overlayButtonScale) {
        case 'L':
            return {
                size: 64,
                marginLeft: 21,
                marginBottom: 17,
                svgWidth: 32,
                svgOffset: 2,
            }
        case 'S':
            return {
                size: 30,
                marginLeft: 8,
                marginBottom: 5,
                svgWidth: 16,
                svgOffset: -2,
            }
        default:
            return {
                size: 48,
                marginLeft: 16,
                marginBottom: 13,
                svgWidth: 22,
                svgOffset: 2,
            }
    }
}
